import { Icon } from "@booking/components/atoms/media/Icon";
import { IconEnum } from "@booking/enums";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";

import { ColorEnum } from "@/enums";
import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./Label.module.css";

const ref = "label";

interface LabelProps extends Partial<CommonProps> {
  icon?: IconDefinition | IconEnum;
  text: string;
}

function useLabel(props: LabelProps) {
  const {
    color = ColorEnum.DARKGREEN,
    iconColor = color,
    id = createId(ref),
    text = "",
  } = props;
  const className = clsx(styles[ref], color && styles[color], props.className);

  return {
    className,
    icon: props.icon,
    iconColor,
    id,
    text,
  };
}

function Label(props: LabelProps) {
  const { className, icon, iconColor, id, text } = useLabel(props);

  return text.length > 0 ? (
    <p className={className} id={id}>
      {icon && <Icon color={iconColor} name={icon} noPadding />}
      {text}
    </p>
  ) : null;
}

export default Label;
export { Label, type LabelProps };
